import { useContext, createContext } from "react";
import { baseURL } from "../lib";
import { useAuth } from "./AuthContext";
import axios from 'axios'

const CourseContext = createContext()

const CourseProvider = ({ children }) => {
    const { headers, toast, restaurantId } = useAuth();

    const getAllCourses = async (filter) => {
        const { totalRenderedRecords, limit, filter: coursesFilter, restaurant_id } = filter

        try {
            const { data } = await axios.get(`${baseURL}/course/list?limit=${limit ? limit : null}&totalRenderedRecords=${totalRenderedRecords >= 0 ? totalRenderedRecords : null}&restaurant_id=${restaurantId ? restaurantId : null}&filter=${coursesFilter !== '' ? coursesFilter : null}`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Course', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const getSingleCourse = async (id) => {
        try {
            let { data } = await axios.get(`${baseURL}/course/single-course/${id}`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Course', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const createCourse = async (courseDetail) => {
        try {
            const { data } = await axios.post(`${baseURL}/course/create`, courseDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Course', detail: data.message, life: 3000 })
                }, 500);
                return data;
            } else {
                toast.current?.show({ severity: 'error', summary: 'Course', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    toast.current?.show({ severity: 'error', summary: 'Course', detail: errors[0].msg, life: 3000 })
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'Course', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    const updateCourse = async (id, courseDetail) => {
        try {
            const { data } = await axios.put(`${baseURL}/course/update/${id}`, courseDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Course', detail: data.message, life: 3000 })
                }, 500);
                return data;
            } else {
                toast.current?.show({ severity: 'error', summary: 'Course', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    toast.current?.show({ severity: 'error', summary: 'Course', detail: errors[0].msg, life: 3000 })
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'Course', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    const deleteCourse = async (id) => {
        try {
            const { data } = await axios.delete(`${baseURL}/course/delete/${id}`, { headers });
            if (data.error === false) {
                toast.current.show({ severity: 'success', summary: 'Course', detail: data.message, life: 3000 })
            } else {
                toast.current.show({ severity: 'error', summary: 'Course', detail: data.message, life: 3000 })
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Course', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    return (
        <CourseContext.Provider value={{ getAllCourses, getSingleCourse, createCourse, updateCourse, deleteCourse }}>
            {children}
        </CourseContext.Provider>
    )
}

const useCourse = () => useContext(CourseContext)

export { useCourse, CourseProvider }